import { RepContext, RepMutations, RepActions } from "./types";
import { User } from "@/models/user_schema";
import RepService from "@/services/rep_service";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { SalesRegionsStringType } from "@/models/map/region_type";

const repService = new RepService();


const formatSalesRegion = (str: string): SalesRegionsStringType => {
  if (str.includes('-')) {
        return str.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-') as SalesRegionsStringType;
  } else {
        return str.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') as SalesRegionsStringType;
  }
}

export const addAllReps = async (context: RepContext): Promise<void> => {
  try {
    const res = await repService.getReps();
    res.forEach(rep => {
      rep.rep_info!.sales_region = formatSalesRegion(rep.rep_info?.sales_region)
    })
    context.commit(RepMutations.SetRep, res);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
};

export const clearReps = (context: RepContext): void => {
  context.commit(RepMutations.SetRep, [] as User[]);
}

export const fetchSingleRep = async (
  context: RepContext,
  payload: string
): Promise<void> => {
  let res;
  try {
    res = await repService.getSingleRep(payload);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
  const reps = context.state.rep;
  const results = [] as User[];
  reps.forEach((rep) => {
    rep.rep_info!.sales_region = formatSalesRegion(rep.rep_info?.sales_region)
    if (rep._id === res._id) {
      res.rep_info!.sales_region = formatSalesRegion(res.rep_info?.sales_region)
      results.push(res);
    } else {
      results.push(rep);
    }
  });
  context.commit(RepMutations.SetRep, results);
  context.commit(RepMutations.SetSelected, res);
};

export const editRep = async (
  context: RepContext,
  payload: User
): Promise<void> => {
  const results = [] as User[];
  const reps = context.state.rep;
  try {
    const res = await repService.updateRep(payload, payload._id);
    reps.forEach((rep) => {
      if (rep._id === res._id) {
        results.push(res);
      } else {
        results.push(rep);
      }
    });
    context.commit(RepMutations.SetRep, results);
    context.commit(RepMutations.SetSelected, payload);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
};

export const setSelectedRep = (
  context: RepContext,
  payload: User | null
): void => {
  context.commit(RepMutations.SetSelected, payload);
};

export const deleteRep = async (
  context: RepContext,
  payload: string
): Promise<void> => {
  let results = [] as User[];
  const reps = context.state.rep;
  try {
    await repService.deleteRep(payload);
    results = reps.filter((rep) => {
      return rep._id !== payload;
    });
    context.commit(RepMutations.SetRep, results);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
};

export const addRep = (context: RepContext, payload: User): void => {
  const reps = context.state.rep;
  reps.unshift(payload);
  context.commit(RepMutations.SetRep, reps);
};
